import VisaLight from 'src/Assets/Svg/payment-systems/visa.svg?react'
import MastercardLight from 'src/Assets/Svg/payment-systems/masterCard.svg?react'
import ApplePay from 'src/Assets/Svg/payment-systems/applePay.svg?react'
import GooglePay from 'src/Assets/Svg/payment-systems/googlePay.svg?react'
import Amazon from 'src/Assets/Svg/payment-systems/amazonPay.svg?react'
import Link from 'src/Assets/Svg/payment-systems/linkPay.svg?react'
import CashApp from 'src/Assets/Svg/payment-systems/cashapp.svg?react'
import Crypto from 'src/Assets/Svg/payment-systems/crypto.svg?react'
import BankTransfer from 'src/Assets/Svg/payment-systems/banktransfer.svg?react'
import Klarna from 'src/Assets/Svg/payment-systems/klarna.svg?react'
import Bancontact from 'src/Assets/Svg/payment-systems/bankcontact.svg?react'
import Giropay from 'src/Assets/Svg/payment-systems/giro.svg?react'
import Ideal from 'src/Assets/Svg/payment-systems/ideal.svg?react'
import Sepa from 'src/Assets/Svg/payment-systems/sepa.svg?react'
import CartesBancaires from 'src/Assets/Svg/payment-systems/cb.svg?react'
import KoreanCards from 'src/Assets/Svg/payment-systems/koreacard.svg?react'
import KakaoPay from 'src/Assets/Svg/payment-systems/kakao.svg?react'
import NaverPay from 'src/Assets/Svg/payment-systems/npay.svg?react'
import Payco from 'src/Assets/Svg/payment-systems/payco.svg?react'
import SamsungPay from 'src/Assets/Svg/payment-systems/samspay.svg?react'
import Alipay from 'src/Assets/Svg/payment-systems/ali.svg?react'
import WechatPay from 'src/Assets/Svg/payment-systems/weechat.svg?react'
import Przelewy24 from 'src/Assets/Svg/payment-systems/prz.svg?react'
import Pix from 'src/Assets/Svg/payment-systems/pix.svg?react'
import Afterpay from 'src/Assets/Svg/payment-systems/afterpay.svg?react'
import TD from 'src/Assets/Svg/payment-systems/tdbank.svg?react'
import ACH from 'src/Assets/Svg/payment-systems/ach.svg?react'
import VisaDark from 'src/Assets/Svg/payment-systems/dark/visa.svg?react'
import MastercardDark from 'src/Assets/Svg/payment-systems/dark/masterCard.svg?react'
import ApplePayDark from 'src/Assets/Svg/payment-systems/dark/applePay.svg?react'
import GooglePayDark from 'src/Assets/Svg/payment-systems/dark/googlePay.svg?react'
import AmazonDark from 'src/Assets/Svg/payment-systems/dark/amazonPay.svg?react'
import LinkDark from 'src/Assets/Svg/payment-systems/dark/linkPay.svg?react'
import CashAppDark from 'src/Assets/Svg/payment-systems/dark/cashapp.svg?react'
import CryptoDark from 'src/Assets/Svg/payment-systems/dark/crypto.svg?react'
import ACHDark from 'src/Assets/Svg/payment-systems/dark/ach.svg?react'
import AfterpayDark from 'src/Assets/Svg/payment-systems/dark/afterpay.svg?react'
import KlarnaDark from 'src/Assets/Svg/payment-systems/dark/klarna.svg?react'
import TDDark from 'src/Assets/Svg/payment-systems/dark/tdbank.svg?react'
import BankTransferDark from 'src/Assets/Svg/payment-systems/dark/banktransfer.svg?react'
import SepaDark from 'src/Assets/Svg/payment-systems/dark/sepa.svg?react'
import CartesBancairesDark from 'src/Assets/Svg/payment-systems/dark/cb.svg?react'
import GiropayDark from 'src/Assets/Svg/payment-systems/dark/giro.svg?react'
import IdealDark from 'src/Assets/Svg/payment-systems/dark/ideal.svg?react'
import BancontactDark from 'src/Assets/Svg/payment-systems/dark/bankcontact.svg?react'
import KoreanCardsDark from 'src/Assets/Svg/payment-systems/dark/koreacard.svg?react'
import KakaoPayDark from 'src/Assets/Svg/payment-systems/dark/kakao.svg?react'
import NaverPayDark from 'src/Assets/Svg/payment-systems/dark/npay.svg?react'
import PaycoDark from 'src/Assets/Svg/payment-systems/dark/payco.svg?react'
import SamsungPayDark from 'src/Assets/Svg/payment-systems/dark/samspay.svg?react'
import AlipayDark from 'src/Assets/Svg/payment-systems/dark/ali.svg?react'
import WechatPayDark from 'src/Assets/Svg/payment-systems/dark/weechat.svg?react'
import Przelewy24Dark from 'src/Assets/Svg/payment-systems/dark/prz.svg?react'
import PixDark from 'src/Assets/Svg/payment-systems/dark/pix.svg?react'
import { PaymentMethodEnum, WalletPaymentMethod } from 'src/Constants/enums'

export interface PaymentMethodIcon {
  id: string
  name: string
  Component: React.ComponentType
  ComponentDark: React.ComponentType
}

export const PAYMENT_METHODS: Record<string, PaymentMethodIcon> = {
  // Global payment methods
  visa: {
    id: 'visa',
    name: 'Visa',
    Component: VisaLight,
    ComponentDark: VisaDark,
  },
  mastercard: {
    id: 'mastercard',
    name: 'MasterCard',
    Component: MastercardLight,
    ComponentDark: MastercardDark,
  },
  applepay: {
    id: 'applepay',
    name: 'Apple Pay',
    Component: ApplePay,
    ComponentDark: ApplePayDark,
  },
  googlepay: {
    id: 'googlepay',
    name: 'Google Pay',
    Component: GooglePay,
    ComponentDark: GooglePayDark,
  },
  amazon: {
    id: 'amazon',
    name: 'Amazon Pay',
    Component: Amazon,
    ComponentDark: AmazonDark,
  },
  link: { id: 'link', name: 'Link', Component: Link, ComponentDark: LinkDark },

  // Local payment methods
  cashapp: {
    id: 'cashapp',
    name: 'Cash App Pay',
    Component: CashApp,
    ComponentDark: CashAppDark,
  },
  crypto: {
    id: 'crypto',
    name: 'Crypto',
    Component: Crypto,
    ComponentDark: CryptoDark,
  },
  ach: {
    id: 'ach',
    name: 'ACH Direct Debit',
    Component: ACH,
    ComponentDark: ACHDark,
  },
  afterpay: {
    id: 'afterpay',
    name: 'Afterpay / Clearpay',
    Component: Afterpay,
    ComponentDark: AfterpayDark,
  },
  klarna: {
    id: 'klarna',
    name: 'Klarna',
    Component: Klarna,
    ComponentDark: KlarnaDark,
  },
  pad: {
    id: 'pad',
    name: 'Canadian pre‑authorized debits (PAD)',
    Component: TD,
    ComponentDark: TDDark,
  },
  banktransfer: {
    id: 'banktransfer',
    name: 'Bank transfer',
    Component: BankTransfer,
    ComponentDark: BankTransferDark,
  },
  sepa: {
    id: 'sepa',
    name: 'SEPA Direct Debit',
    Component: Sepa,
    ComponentDark: SepaDark,
  },
  cartes: {
    id: 'cartes',
    name: 'Cartes Bancaires',
    Component: CartesBancaires,
    ComponentDark: CartesBancairesDark,
  },
  giropay: {
    id: 'giropay',
    name: 'giropay',
    Component: Giropay,
    ComponentDark: GiropayDark,
  },
  ideal: {
    id: 'ideal',
    name: 'iDEAL',
    Component: Ideal,
    ComponentDark: IdealDark,
  },
  bancontact: {
    id: 'bancontact',
    name: 'Bancontact',
    Component: Bancontact,
    ComponentDark: BancontactDark,
  },
  korean: {
    id: 'korean',
    name: 'Korean cards',
    Component: KoreanCards,
    ComponentDark: KoreanCardsDark,
  },
  kakao: {
    id: 'kakao',
    name: 'Kakao Pay',
    Component: KakaoPay,
    ComponentDark: KakaoPayDark,
  },
  naver: {
    id: 'naver',
    name: 'Naver Pay',
    Component: NaverPay,
    ComponentDark: NaverPayDark,
  },
  payco: {
    id: 'payco',
    name: 'PAYCO',
    Component: Payco,
    ComponentDark: PaycoDark,
  },
  samsung: {
    id: 'samsung',
    name: 'Samsung Pay',
    Component: SamsungPay,
    ComponentDark: SamsungPayDark,
  },
  alipay: {
    id: 'alipay',
    name: 'Alipay',
    Component: Alipay,
    ComponentDark: AlipayDark,
  },
  wechat: {
    id: 'wechat',
    name: 'WeChat Pay',
    Component: WechatPay,
    ComponentDark: WechatPayDark,
  },
  przelewy24: {
    id: 'przelewy24',
    name: 'Przelewy24',
    Component: Przelewy24,
    ComponentDark: Przelewy24Dark,
  },
  pix: { id: 'pix', name: 'Pix', Component: Pix, ComponentDark: PixDark },
}

export const GLOBAL_PAYMENT_METHODS: PaymentMethodIcon[] = [
  PAYMENT_METHODS.visa,
  PAYMENT_METHODS.mastercard,
  PAYMENT_METHODS.applepay,
  PAYMENT_METHODS.googlepay,
  PAYMENT_METHODS.amazon,
  PAYMENT_METHODS.link,
]

const LOCAL_PAYMENT_METHODS: Record<string, string[]> = {
  // United States
  US: ['cashapp', 'crypto', 'ach', 'afterpay', 'klarna'],

  // Canada
  CA: ['afterpay', 'pad'],

  // New Zealand
  NZ: ['afterpay'],

  // United Kingdom
  GB: ['afterpay', 'klarna', 'banktransfer'],

  // France
  FR: ['klarna', 'cartes', 'banktransfer'],

  // Germany
  DE: ['klarna', 'giropay', 'banktransfer'],

  // Netherlands
  NL: ['klarna', 'ideal', 'banktransfer'],

  // Belgium
  BE: ['klarna', 'bancontact', 'banktransfer'],

  // South Korea
  KR: ['korean', 'kakao', 'naver', 'payco', 'samsung'],

  // China
  CN: ['alipay', 'wechat'],

  // Poland
  PL: ['przelewy24', 'banktransfer'],

  // Brazil
  BR: ['pix'],

  // Austria
  AT: ['klarna', 'banktransfer'],

  // Denmark
  DK: ['klarna', 'banktransfer'],

  // Finland
  FI: ['klarna', 'banktransfer'],

  // Italy
  IT: ['klarna', 'banktransfer'],

  // Norway
  NO: ['klarna', 'banktransfer'],

  // Spain
  ES: ['klarna', 'banktransfer'],

  // Sweden
  SE: ['klarna', 'banktransfer'],

  // Switzerland
  CH: ['klarna', 'banktransfer'],

  // Japan
  JP: ['banktransfer'],

  // Mexico
  MX: ['banktransfer'],
}

const COUNTRIES_WITH_BANK_TRANSFER = [
  'BG',
  'HR',
  'CY',
  'CZ',
  'EE',
  'GR',
  'HU',
  'IS',
  'IE',
  'LV',
  'LI',
  'LT',
  'LU',
  'MT',
  'MC',
  'PT',
  'RO',
  'SM',
  'SK',
  'SI',
  'VA',
]

COUNTRIES_WITH_BANK_TRANSFER.forEach((countryCode) => {
  LOCAL_PAYMENT_METHODS[countryCode] = ['banktransfer']
})

const WALLET_ICON_IDS: Record<WalletPaymentMethod, string> = {
  [PaymentMethodEnum.APPLE_PAY]: PAYMENT_METHODS.applepay.id,
  [PaymentMethodEnum.GOOGLE_PAY]: PAYMENT_METHODS.googlepay.id,
}

export const getPaymentMethodsForCountry = (
  countryCode: string,
  walletMethods: WalletPaymentMethod[] = [],
): PaymentMethodIcon[] => {
  const localMethodKeys = LOCAL_PAYMENT_METHODS[countryCode] || []
  const localMethods = localMethodKeys
    .map((key) => PAYMENT_METHODS[key])
    .filter(Boolean)

  const walletIconIds = walletMethods.map((method) => WALLET_ICON_IDS[method])

  return [...GLOBAL_PAYMENT_METHODS, ...localMethods].filter(
    (method) => !walletIconIds.includes(method.id),
  )
}
